export default __webpack_public_path__ + "static/media/no-fees.ed46c997.svg";